import { z } from 'zod/v4';

export const AnalysisCreateResponseSchema = z.object({
  analysisId: z.string(),
  filesCount: z.number().int().nonnegative(),
});

export type AnalysisCreateResponseType = z.infer<
  typeof AnalysisCreateResponseSchema
>;
